export default "__VITE_ASSET__INFM$Lwd__"